import { Injectable } from '@angular/core';
import { DspxBaseFormComponent } from 'dspx-core';
import { FormCommonHelperService } from './formCommon.service';
import { FormGroup } from '@angular/forms';
import { FORM_08_PAGE_MAPPINGS } from '../constants/app-data.constants';
import { Form0408SubstanceService } from './form0408-substance.service';

@Injectable({
  providedIn: 'root'
})
export class Form08HelperService {
  constructor(
    private formCommonHelperService: FormCommonHelperService,
    private form0408SubstanceService: Form0408SubstanceService
  ) { }

  // basicInfo functions ------------------------------------------------------------
  public isHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page1']?.['basicInfo'];

      if (section == null) {
        return false;
      }

      result =
        (section?.['checkboxIndividualHealthPractitionersCanObtain'] ?? false) === true
        &&
        (section?.['checkboxS2sS3sCanBeObtainedFromPharmacy'] ?? false) === true
        &&
        (section?.['checkboxOnlyHealthPractitionersCanAdminister'] ?? false) === true;
    }

    return result;
  };

  public isNonHspPermit(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page1']?.['basicInfo'];

      if (section == null) {
        return false;
      }

      result = (section?.['checkboxNonHSPpermitConfirmationPoints'] ?? false) === true;
    }

    return result;
  };

  public isLicenceManufacturing(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page1']?.['basicInfo'];

      if (section == null) {
        return false;
      }

      result = (section?.['checkboxLicenceConfirmationPoints'] ?? false) !== true
        ||
        (
          section?.['supplyQuestion'] !== 'Yes-Itemsmaybesuppliedtoexternalorganisations'
          &&
          section?.['potentialManufacturingLicence'] !== 'Yes-Theremaybemanufacturingactivities'
        );
    }

    return !result;
  };

  public isLicenceIndent(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page1']?.['basicInfo'];

      if (section == null) {
        return false;
      }

      result = (section?.['checkboxLicenceConfirmationPoints'] ?? false) === true
        &&
        (section?.['checkboxIndentConfirmationPoints'] ?? false) === true;
    }

    return result;
  };

  public isLicenceNonManufactNonIndent(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page1']?.['basicInfo'];

      if (section == null) {
        return false;
      }

      result = (section?.['checkboxLicenceConfirmationPoints'] ?? false) === true
        &&
        section?.['indentQuestion'] === "Yes-Someorallsubstanceswouldbestoredontheorganisation'sownedorrentedpremises";
    }

    return result;
  };

  // Health Service Use -----------------------------------------------------------------
  public isHspDermalInjectables(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result =
        (section?.['checkbox_InfectionControlGuidelines'] ?? false) === true
        &&
        (section?.['checkbox_AdvertisingS4s'] ?? false) === true;
    }

    return result;
  };

  public isHspDermalInjectablesNothingElse(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = this.isHspDermalInjectables(data) &&
        !(
          (section?.['checkbox_VaccinationServices'] ?? false) === true
          ||
          (section?.['checkbox_NonEmergencyPatientTransport'] ?? false) === true
          ||
          (section?.['checkbox_DentalServices'] ?? false) === true
          ||
          (section?.['checkbox_OpticalHealthServices'] ?? false) === true
          ||
          (section?.['checkbox_MentalHealthServices'] ?? false) === true
          ||
          (section?.['checkbox_MedicalImaging'] ?? false) === true
          ||
          (section?.['checkbox_ClinicalTrials'] ?? false) === true
          ||
          (section?.['checkbox_OtherSpecialisedHealthService'] ?? false) === true
        );
    }

    return result;
  };

  public isVetHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = section?.['healthServiceBroadCategory'] === 'Animal health services'
        ||
        section?.['vetAdmin'] === 'Yes, animal health services only';
    }

    return result;
  };

  public isAgedCareHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = (section?.['checkboxAgedCare'] ?? false) === true;
    }

    return result;
  };

  public isAgedCareHspNothingElse(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result =
        (section?.['checkboxAgedCare'] ?? false) !== true
        ||
        (section?.['checkboxHospital'] ?? false) === true
        ||
        (section?.['checkboxGeneralPractice'] ?? false) === true
    }

    return !result;
  };

  public isHospitalHSP(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = (section?.['hospitalConfirmation'] ?? false) === true;
    }

    return result;
  };

  public isDayProcedureCentreHsp(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses'];

      if (section == null) {
        return false;
      }

      result = false;
    }

    return result;
  };


  public isSchedule2Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule2Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule3Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule3Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule4Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule4Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule4DDSubstance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule4DDSubstance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule7Substance(data: any) {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule7Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule7LRSubstance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule7LRSubstance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule8Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule8Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isSchedule9Substance(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceHSP = section?.['substanceHSP'];
      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isSchedule9Substance(substanceHSP, substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isCannabisAddition(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceNonHSPpermit = section?.['substanceNonHSPpermit'];
      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isCannabisAddition(substanceNonHSPpermit, substanceLicence);
    }

    return result;
  }

  public isNitrousAddition(data: any): boolean {
    let result = false;

    if (data?.[0]?.form?.tabs != null) {
      const sectionIndex = +(data?.[1]?.trim());
      const section = data?.[0]?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1']?.[sectionIndex];

      if (section == null) {
        return false;
      }

      const substanceLicence = section?.['substanceLicence'];

      result = this.form0408SubstanceService.isNitrousAddition(substanceLicence);
    }

    return result;
  }

  private countOfScheduleSubstance(data: any, scheduledSubstanceFunction: (model: any[]) => boolean): number {
    let countOfScheduleSubstance: number = 0;

    if (data?.form?.tabs != null) {
      const repeatingSections = data?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1'];

      if (Array.isArray(repeatingSections)) {
        repeatingSections.forEach((section, index) => {
          let model: any[] = [data, index.toString()];
          let result = scheduledSubstanceFunction(model);
          if (result === true) {
            countOfScheduleSubstance++;
          }
        });
      }
    }

    return countOfScheduleSubstance;
  }

  private isAnyOfScheduleSubstanceType(data: any, substanceGroupControl: string, scheduledSubstanceFunction: (model: any[]) => boolean): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page3']?.['sectionb7c986556b89479bb7d82114f15eccad'];

      result = (section?.[substanceGroupControl] ?? false) === true
        ||
        this.countOfScheduleSubstance(data, (d) => scheduledSubstanceFunction(d)) > 0;
    }

    return result;
  }

  public isSchedule2SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data, 's2group', (d) => this.isSchedule2Substance(d));
    }

    return result;
  }

  public isSchedule3SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data, 's3group', (d) => this.isSchedule3Substance(d));
    }

    return result;
  }

  public isSchedule4SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page3']?.['sectionb7c986556b89479bb7d82114f15eccad'];

      result = this.isAnyOfScheduleSubstanceType(data, 's4group', (d) => this.isSchedule4Substance(d))
        ||
        section?.['radioButtonGroup_StandardMedsYesNo'] === 'Yes'
        ||
        section?.['radioButtonGroup_StandardMedsYesNo'] === 'No';
    }

    return result;
  }

  public isSchedule4DDSubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page3']?.['sectionb7c986556b89479bb7d82114f15eccad'];

      result = section?.['s4DDsGroupQuestion'] === 'Yes'
        ||
        this.countOfScheduleSubstance(data, (d) => this.isSchedule4DDSubstance(d)) > 0;
    }

    return result;
  }

  public isSchedule7SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data, 's7group', (d) => this.isSchedule7Substance(d));
    }

    return result;
  }

  public isSchedule7LRSubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page3']?.['sectionb7c986556b89479bb7d82114f15eccad'];

      result = section?.['s7LRGroupQuestion'] === 'Yes'
        || section?.['questionf1d0fdd669594125b71d1a4b940e5adb'] === 'Yes'
        || this.countOfScheduleSubstance(data, (d) => this.isSchedule7LRSubstance(d)) > 0;
    }

    return result;
  }

  public isSchedule8SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data, 's8group', (d) => this.isSchedule8Substance(d));
    }

    return result;
  }

  public isSchedule9SubstanceOrGroup(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.isAnyOfScheduleSubstanceType(data, 's9group', (d) => this.isSchedule9Substance(d));
    }

    return result;
  }

  public isTherapeuticGoods(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.manufacturing]?.['page_6']?.['humanOrAnimalEndUserUse'] === "Yes"
        ||
        data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.healthpractitioneractivities]?.['healthPractitionerActivitiesFooter']?.['pharmacySupplyToExternal'] === "Yes"
        ||
        data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.authorisedsupply]?.['page_8']?.['indentTherapeuticGoods'] === "Yes"
        ||
        data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.storageandaccess]?.['page_9']?.['supplyingTherapeuticGoods'] === "Yes";
    }

    return result
  }

  public noSchedule8or9Substance(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isSchedule8Substance(d)) !== 1
        &&
        this.countOfScheduleSubstance(data, (d) => this.isSchedule9Substance(d)) !== 1;
    }

    return result;
  }

  public licencePermitTypeTopOfForm(data: any): string {
    let result = '';

    if (data?.form?.tabs != null) {
      result = this.isLicenceManufacturing(data) && (this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data))
        ? '23 MP4 (a licence to manufacture S4s (and possibly S2s/S3s/S7s))'
        : this.isLicenceManufacturing(data) &&
          (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data)) &&
          !this.isSchedule4SubstanceOrGroup(data) &&
          !this.isSchedule4DDSubstanceOrGroup(data)
          ? '23 MP237 (a licence to manufacture S2s/S3s/S7s)'
          : this.isLicenceNonManufactNonIndent(data) && (this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data))
            ? '24 WP4 (a licence to store, supply, but not manufacture S4s (and possibly S2s/S3s/S7s))'
            : this.isLicenceNonManufactNonIndent(data) &&
              (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data)) &&
              !this.isSchedule4SubstanceOrGroup(data) &&
              !this.isSchedule4DDSubstanceOrGroup(data)
              ? '24 WP237 (a licence to store, supply, but not manufacture S2s/S3s/S7s)'
              : this.isLicenceIndent(data) && (this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data))
                ? '24 WP4 Indent (a licence to direct supply by indent, but not store S4s (and possibly S2s/S3s/S7s))'
                : this.isLicenceIndent(data) &&
                  (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data)) &&
                  !this.isSchedule4SubstanceOrGroup(data) &&
                  !this.isSchedule4DDSubstanceOrGroup(data)
                  ? '24 WP237 Indent (a licence to direct supply by indent, but not store S2s/S3s/S7s)'
                  : this.isNonHspPermit(data) &&
                    (this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data)) &&
                    ('Industrial' !== data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] && data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] !== undefined) &&
                    !this.isVetHsp(data)
                    ? '25 Permit 8,9 (a permit for research or other uses which includes S8s/S9s (and possibly other substances))'
                    : !this.isNonHspPermit(data) ||
                      this.isSchedule8SubstanceOrGroup(data) ||
                      this.isSchedule9SubstanceOrGroup(data) ||
                      'Industrial' === data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] ||
                      this.isVetHsp(data)
                      ? this.isNonHspPermit(data) &&
                        (this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data)) &&
                        'Industrial' === data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] &&
                        !this.isVetHsp(data)
                        ? '27 Permit 8,9 (an industrial permit which includes S8s/S9s (and possibly other substances))'
                        : !this.isNonHspPermit(data) ||
                          this.isSchedule8SubstanceOrGroup(data) ||
                          this.isSchedule9SubstanceOrGroup(data) ||
                          ('Industrial' !== data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] && data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['nonHSPpermitTypes'] !== undefined) ||
                          this.isVetHsp(data)
                          ? this.isHsp(data) &&
                            (((data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                              ('Yes' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] || this.isHospitalHSP(data))) ||
                              (!(data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                                'More than 100' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']))
                            ? '29 HSP Type D (a health service permit with either –multiple sites (with beds) OR – a single site with more than 100 beds)'
                            : (this.isHsp(data) &&
                              (((data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                                ('No' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] || !this.isHospitalHSP(data))) ||
                                (!(data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                                  '31 to 100' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']))) ||
                              (this.isVetHsp(data) && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true)
                              ? '29 HSP Type C (a health service permit with either –multiple sites (with no beds) OR – a single site with 31 to 100 beds)'
                              : this.isHsp(data) &&
                                ((!(data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                                  '1 to 30' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']) ||
                                  (this.isAgedCareHsp(data) &&
                                    !this.isHospitalHSP(data) &&
                                    !(data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true))
                                ? '29 HSP Type B (a health service permit for either - a single site with 31 to 100 beds OR – a residential aged care facility)'
                                : this.isHsp(data) &&
                                  ('Yes' !== data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] && data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] !== undefined) &&
                                  this.isHspDermalInjectablesNothingElse(data)
                                  ? 'COSMETIC ONLY - 29 HSP Type A (a health service permit for a single site with no over-night beds)'
                                  : (this.isHsp(data) &&
                                    !(
                                      (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true ||
                                      'Yes' === data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] ||
                                      this.isAgedCareHsp(data) ||
                                      this.isHospitalHSP(data)
                                    )) ||
                                    (this.isVetHsp(data) &&
                                      !(data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true &&
                                      false == this.isHspDermalInjectablesNothingElse(data))
                                    ? '29 HSP Type A (a health service permit for a single site with no over-night beds)'
                                    : ''
                          : '27 Permit 2347 (an industrial permit which does not include S8s/S9s)'
                      : '25 Permit 2347 (a permit for research or other uses permit which does not include S8s/S9s)';
    }

    return result;
  }

  public legalEntityTopOfForm(data: any): string {
    let result = '';

    if (data?.form?.tabs != null) {
      result = data.form.tabs?.['tab1']?.['page5']?.['applicantDetails']?.['legalEntityName'];
    }

    return result;
  }

  public tradingNameTopOfForm(data: any) {
    let result = '';

    if (data?.form?.tabs != null) {
      result = data.form.tabs?.['tab1']?.['page5']?.['applicantDetails']?.['tradingName'];
    }

    return result;
  }

  public s8or9LicenceTopOfForm(data: any) {
    const result = this.isLicenceManufacturing(data) && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
      ? '21 MA (a licence to manufacture S8s/S9s)'
      : this.isLicenceNonManufactNonIndent(data) && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
        ? '22 WA (a licence to store, supply, but not manufacture S8s/S9s)'
        : this.isLicenceIndent(data) && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
          ? '22 WA Indent (a licence to direct supply by indent, but not store S8s/S9s)'
          : '';
  }

  public feeTopOfForm(data: any): number {
    let result = 0;

    if (data?.form?.tabs != null) {
      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
        && (this.isSchedule4Substance(data) || this.isSchedule4DDSubstance(data))
      ) {
        result = 2908.4;
      }

      if (
        (this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
        && (this.isSchedule2Substance(data) || this.isSchedule3Substance(data) || this.isSchedule7Substance(data) || this.isSchedule7LRSubstance(data))
        && false == this.isSchedule4Substance(data)
        && false == this.isSchedule4DDSubstance(data)
      ) {
        result = 2908.4;
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8Substance(data) || this.isSchedule9Substance(data))
      ) {
        result = 1543.2;
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule4Substance(data) || this.isSchedule4DDSubstance(data))
      ) {
        result = 1365.2;
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule2Substance(data) || this.isSchedule3Substance(data) || this.isSchedule7Substance(data) || this.isSchedule7LRSubstance(data))
        && false == this.isSchedule4Substance(data)
        && false == this.isSchedule4DDSubstance(data)) {
        result = 1365.2;
      }

      if (this.isLicenceIndent(data)
        && (this.isSchedule9Substance(data) || this.isSchedule8Substance(data))
        && (this.isSchedule2Substance(data) || this.isSchedule3Substance(data) || this.isSchedule4Substance(data) || this.isSchedule4DDSubstance(data) || this.isSchedule7Substance(data) || this.isSchedule7Substance(data))) {
        result = 2377.6;
      }

      if (this.isLicenceIndent(data)) {
        result = 1188.8;
      }

      if (this.isNonHspPermit(data)
        && (this.isSchedule9Substance(data) || this.isSchedule8Substance(data))
      ) {
        result = 1543.2;
      }

      if (this.isNonHspPermit(data)) {
        result = 1365.2;
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && (this.isHospitalHSP(data) || 'Yes' == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'])
      ) {
        result = 1543.2;
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && (false == this.isHospitalHSP(data) || 'No' == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'])
      ) {
        result = 1543.2;
      }

      if (this.isHsp(data)
        && false == (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && 'More than 100' == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        result = 1543.2;
      }

      if (this.isHsp(data)
        && false == (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && '31 to 100' == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        result = 1543.2;
      }

      if (this.isHsp(data)
        && false == (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && '1 to 30' == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        result = 1188.8;
      }

      if (this.isHsp(data)
        && false == (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && ('No' !== data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] && data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'] !== undefined)
        && false == this.isAgedCareHsp(data)
      ) {
        result = 1188.8;
      }

      if (this.isHsp(data)
        && this.isAgedCareHsp(data)
        && false == (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false)
        && false == this.isHospitalHSP(data)
      ) {
        result = 1188.8;
      }
    }

    return result;
  }

  public licPerLast6DigitsfeeTopOfForm(data: any) {
    let result = '';

    if (data?.form?.tabs != null) {
      result = data.form.tabs?.['tab1']?.['page16']?.['page_14']?.['licencePermit6Digits'];
    }

    return result;
  }

  private sumRepeatingSectionField(repeatingSection: any, targetField: string): number {
    let total = 0;

    if (Array.isArray(repeatingSection)) {
      total = repeatingSection.reduce((sum, section) => {
        const value = Number(section[targetField]);
        return sum + (isNaN(value) ? 0 : value);
      }, 0);
    }

    return total;
  }

  public maxHoldingIndividualTotal(data: any) {
    let result = 0;

    if (data?.form?.tabs != null) {
      const repeatingSection = data?.form?.tabs?.['tab1']?.['page3']?.['repeatingBlockTemplate_1'];

      result = this.sumRepeatingSectionField(repeatingSection, 'maxHoldingIndividual');
    }

    return result;
  }

  public cannabisAddition2(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isCannabisAddition(d)) > 0;
    }

    return result
  }

  public nitrousAddition2(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isNitrousAddition(d)) > 0;
    }

    return result
  }

  public nonHSPWithAdmin(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      result = (data.form.tabs?.['tab1']?.['page4']?.['useResearchIndustry']?.['adminOrSupplyByHealthPracOnly'] ?? false) === true;
    }

    return result
  }

  public totalYearsExperienceValidation(data: any) {
    let result = 0;

    if (data?.form?.tabs != null) {
      const repeatingSection = data?.form?.tabs?.['tab1']?.['page7']?.['repeatingBlockTemplate_4'];

      result = this.sumRepeatingSectionField(repeatingSection, 'yearsInRole');
    }

    return result;
  }

  public totalYearsExperience(data: any) {
    let result = 0;

    if (data?.form?.tabs != null) {
      const repeatingSection = data?.form?.tabs?.['tab1']?.['page7']?.['repeatingBlockTemplate_4'];

      result = this.sumRepeatingSectionField(repeatingSection, 'yearsInRole');
    }

    return result;
  }

  public hpAdminInitiateSelected(data: any): boolean {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.healthpractitioneractivities]?.['healthPractitionerActivitiesFooter'];

      if (section == null) {
        return false;
      }

      result = "Yes" == section?.['onlyMedPracsInitiating'] ||
        (section?.['medicalPractitioner'] ?? false) === true ||
        (section?.['nurseImmuniser'] ?? false) === true ||
        (section?.['nursePractitioner'] ?? false) === true ||
        (section?.['nurseAdvancedLifeSupport'] ?? false) === true ||
        (section?.['ripnNurse'] ?? false) === true ||
        (section?.['midwifeNoEndorsement'] ?? false) === true ||
        (section?.['midwifeEndorsed'] ?? false) === true ||
        (section?.['pharmacistImmuniser'] ?? false) === true ||
        (section?.['dentist'] ?? false) === true ||
        (section?.['podiatristNoEndorsement'] ?? false) === true ||
        (section?.['podiatristEndorsed'] ?? false) === true ||
        (section?.['optometristNoEndorsement'] ?? false) === true ||
        (section?.['optometristEndorsed'] ?? false) === true ||
        (section?.['dentalOthers'] ?? false) === true ||
        (section?.['covidVaccinators'] ?? false) === true;
    }

    return result
  }

  public hpSupplySelected(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.healthpractitioneractivities]?.['healthPractitionerActivitiesFooter'];

      if (section == null) {
        return false;
      }

      result = "Yes" == section?.['onlyMedPracsInitiating'] ||
        (section?.['medicalPractitioner'] ?? false) === true ||
        (section?.['nursePractitioner'] ?? false) === true ||
        (section?.['ripnNurse'] ?? false) === true ||
        (section?.['midwifeEndorsed'] ?? false) === true ||
        (section?.['dentist'] ?? false) === true ||
        (section?.['podiatristEndorsed'] ?? false) === true ||
        (section?.['optometristEndorsed'] ?? false) === true ||
        this.isVetHsp(data);
    }

    return result
  }

  public hpVerbalOrderSelected(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.healthpractitioneractivities]?.['healthPractitionerActivitiesFooter'];

      if (section == null) {
        return false;
      }

      result = "Yes" == section?.['onlyMedPracsInitiating'] ||
        (section?.['medicalPractitioner'] ?? false) === true ||
        (section?.['nursePractitioner'] ?? false) === true ||
        (section?.['midwifeEndorsed'] ?? false) === true ||
        (section?.['dentist'] ?? false) === true ||
        (section?.['podiatristEndorsed'] ?? false) === true ||
        (section?.['optometristEndorsed'] ?? false) === true;
    }

    return result
  }

  public nitrousAlone(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page3']?.['sectionb7c986556b89479bb7d82114f15eccad'];

      if (section == null) {
        return false;
      }

      result = this.nitrousAddition2(data)
        && this.countOfScheduleSubstance(data, (d) => this.isSchedule4Substance(d)) < 2
        && (section?.['s4group'] ?? false) === false
        && this.isSchedule2SubstanceOrGroup(data) === false
        && this.isSchedule3SubstanceOrGroup(data) === false
        && this.isSchedule8SubstanceOrGroup(data) === false;
    }

    return result;
  }

  public fee(data: any): string {
    if (data?.form?.tabs != null) {
      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data))
        && (this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data))
      ) {
        return '2831.80';
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data))
        && (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data))
        && this.isSchedule4SubstanceOrGroup(data) === false
        && this.isSchedule4DDSubstanceOrGroup(data) === false
      ) {
        return '2831.80';
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule8SubstanceOrGroup(data) || this.isSchedule9SubstanceOrGroup(data))
      ) {
        return '1502.60';
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data))
      ) {
        return '1329.20';
      }

      if ((this.isLicenceManufacturing(data) || this.isLicenceNonManufactNonIndent(data))
        && (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data))
        && this.isSchedule4SubstanceOrGroup(data) === false
        && this.isSchedule4DDSubstanceOrGroup(data) === false
      ) {
        return '1329.20';
      }

      if (this.isLicenceIndent(data)
        && (this.isSchedule9SubstanceOrGroup(data) || this.isSchedule8SubstanceOrGroup(data))
        && (this.isSchedule2SubstanceOrGroup(data) || this.isSchedule3SubstanceOrGroup(data) || this.isSchedule4SubstanceOrGroup(data) || this.isSchedule4DDSubstanceOrGroup(data) || this.isSchedule7SubstanceOrGroup(data) || this.isSchedule7LRSubstanceOrGroup(data))
      ) {
        return '2315.00';
      }

      if (this.isLicenceIndent(data)) {
        return '1157.50';
      }

      if (this.isNonHspPermit(data) && (this.isSchedule9SubstanceOrGroup(data) || this.isSchedule8SubstanceOrGroup(data))) {
        return '1502.60';
      }

      if (this.isNonHspPermit(data)) {
        return '1329.20';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true
        && (this.isHospitalHSP(data) || "Yes" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'])
      ) {
        return '1502.60';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === true
        && (this.isHospitalHSP(data) === false || "No" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds'])
      ) {
        return '1502.60';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === false
        && "More than 100" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        return '1502.60';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === false
        && "31 to 100" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        return '1502.60';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === false
        && "1 to 30" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['numberOfBeds']
      ) {
        return '1157.50';
      }

      if (this.isHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === false
        && "No" == data.form.tabs?.['tab1']?.['page2']?.['healthServiceUses']?.['patientBeds']
        && this.isAgedCareHsp(data) === false
      ) {
        return '1157.50';
      }

      if (this.isHsp(data)
        && this.isAgedCareHsp(data)
        && (data.form.tabs?.['tab1']?.['page5']?.['section5c822114b5154c9c812045441dd6cbdf']?.['additionalSitesOption'] ?? false) === false
        && this.isHospitalHSP(data) === false
      ) {
        return ' 1157.50';
      }
    }

    return '';
  }

  public calculateFee(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {
      const fee = (this.fee(baseForm.model) ?? 0).toString();
      const feeControl = (baseForm.form as FormGroup).get('form.tabs.tab1.page16.page_14.fee');
      if (feeControl && feeControl.value !== fee) {
        feeControl.patchValue(fee);
        feeControl.markAsPristine();
        feeControl.markAsUntouched();
      }
    }
  }

  public updatePersonDetails(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {
      // Get the model values we need for the label
      const section = (baseForm.form as FormGroup).get('form.tabs.tab1.page5.section5c822114b5154c9c812045441dd6cbdf');
      const phoneNumber = section.get('phoneNumber').value;
      const emailAddress = section.get('emailAddress').value;

      if (!!phoneNumber && !!emailAddress) {
        // Get the field control
        const detailControl = this.formCommonHelperService.findFieldByKey(baseForm.fields, 'question38bb2220a3374cb2b8b577592fec7347');
        if (detailControl?.props?.label) {
          detailControl.props.label = `The following contact details have been provided in the Applicant details section of this form: <br/><ul><li>Phone number: ${phoneNumber}</li><li>Email address: ${emailAddress}</li></ul><br/>Will the responsible person being nominated in this section of the form be DIRECTLY contactable using both of these contact details?`;
        }
      }
    }
  }

  public updateSubmissionDetails(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {
      // Get the model values we need for the label
      const section = (baseForm.form as FormGroup).get('form.tabs.tab1.page5.section5c822114b5154c9c812045441dd6cbdf');
      const emailAddress = section.get('emailAddress').value;

      if (!!emailAddress) {
        // Get the field control
        const detailControl = this.formCommonHelperService.findFieldByKey(baseForm.fields, 'textDisplay0_356');
        if (detailControl?.props?.label) {
          detailControl.props.label = `<p>To enable payment of the above fee, an invoice will be sent soon (normally within two working days) after the Department receives this completed form to the main email address that you have nominated on this form (${emailAddress})`;
        }
      }
    }
  }

  public submitPresentationNotSavePresentation(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      const section = data.form.tabs?.['tab1']?.['page16']?.['page_14'];

      if (section == null) {
        return false;
      }

      result = !!(
        ("Immediately" == section?.['readyForInspection'] || (section?.['futureInspectionReadyDate'] ?? false) === true) &&
        //this.personSigningSignature &&
        (section?.['personSigningFirstName'] ?? false) === true &&
        (section?.['personSigningSurname'] ?? false) === true &&
        (section?.['personSigningCurrentRole'] ?? false) === true
      );
    }

    return result;
  }

  public calculateTotalMilligrams(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {

      const section = baseForm.model.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.substances]?.['repeatingBlockTemplate_1'];
      if (section == null) {
        return;
      }

      let totalMilligrams = 0;
      section?.forEach(currentSection => {
        const milligrams = currentSection?.['maxHoldingIndividual']
        if (!isNaN(milligrams) && !isNaN(parseFloat(milligrams))) {
          totalMilligrams += +milligrams;
        }
      });
      const totalMilligramsControl = (baseForm.form as FormGroup).get(`form.tabs.tab1.${FORM_08_PAGE_MAPPINGS.substances}.section4a9eb599400a4f64a10e573eae75e46b.maxHoldingIndividualTotal`);
      if (totalMilligramsControl && totalMilligramsControl.value !== totalMilligrams) {
        totalMilligramsControl.patchValue(totalMilligrams);
        totalMilligramsControl.markAsPristine();
        totalMilligramsControl.markAsUntouched();
      }
    }
  }

  public anyIndividualSubstance8(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isSchedule8Substance(d)) > 0;
    }

    return result;
  }

  public anyIndividualSubstance9(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isSchedule9Substance(d)) > 0;
    }

    return result;
  }

  public anyIndividualSubstanceCannabis(data: any) {
    let result = false;

    if (data?.form?.tabs != null) {
      result = this.countOfScheduleSubstance(data, (d) => this.isCannabisAddition(d)) > 0;
    }

    return result;
  }

  public calculateYearsExperience(baseForm: DspxBaseFormComponent) {
    if (baseForm?.model?.form?.tabs != null) {

      const pageArray = baseForm.model.form.tabs?.['tab1']?.[FORM_08_PAGE_MAPPINGS.responsibleperson];
      if (!Array.isArray(pageArray)) {
        return;
      }

      pageArray.forEach((currentPage, index) => {
        let pageTotalYearsInRole = 0;
        currentPage?.['repeatingBlockTemplate_4']?.forEach(currentSection => {
          const yearsInRole = currentSection?.['yearsInRole']
          if (!isNaN(yearsInRole) && !isNaN(parseFloat(yearsInRole))) {
            pageTotalYearsInRole += +yearsInRole;
          }
        });
        const totalYearsControl = (baseForm.form as FormGroup).get(`form.tabs.tab1.${FORM_08_PAGE_MAPPINGS.responsibleperson}.${index}.experienceFooter.totalYearsExperience`);
        if (totalYearsControl && totalYearsControl.value !== pageTotalYearsInRole) {
          totalYearsControl.patchValue(pageTotalYearsInRole);
          totalYearsControl.markAsDirty();
          totalYearsControl.markAsTouched();
        }
      });
    }
  }

}
